import React from "react";
import { Navigate, useParams } from "react-router-dom";

// Map of deactivated agencies to the agency they should redirect to.
// Keys are matched case-insensitively against the URL :agency param.
const DEACTIVATED_AGENCIES = {
  "dix hills": "2800",
};

// Wraps an agency route. If the requested agency has been deactivated,
// redirect to its replacement agency. Any check id under a deactivated
// agency also redirects to the replacement agency's list.
const AgencyRedirect = ({ children }) => {
  const { agency } = useParams();

  const target = agency && DEACTIVATED_AGENCIES[agency.trim().toLowerCase()];

  if (target) {
    return <Navigate to={`/${target}`} replace />;
  }

  return children;
};

export default AgencyRedirect;
